import { Check, MessageCircle } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { waLink, BG } from "../lib/data";
import { useLang } from "../lib/i18n";
import { SectionBg } from "./SectionBg";

export default function Packages() {
  const { t } = useLang();
  return (
    <section id="packages" className="relative py-24 lg:py-32 border-y border-white/5 overflow-hidden">
      <SectionBg src={BG.packages} opacity={0.3} testid="packages-bg-image" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead tag={t.packages.tag} title={t.packages.title} sub={t.packages.sub} />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {t.packages.items.map((p, i) => (
            <Reveal key={p.id} delay={0.08 * i} className="h-full">
              <div
                data-testid={`package-card-${p.id}`}
                className={`h-full flex flex-col rounded-3xl border p-7 transition-all duration-500 hover:-translate-y-2 ${
                  p.featured
                    ? "border-gold/60 bg-gradient-to-b from-gold/10 to-panel shadow-[0_0_60px_rgba(230,194,128,0.12)]"
                    : "border-white/10 bg-panel/70 hover:border-gold/40"
                }`}
              >
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{p.tag}</p>
                <h3 className="font-display font-extrabold text-white text-2xl mt-3">{p.name}</h3>
                <ul className="mt-6 space-y-3 flex-1">
                  {p.items.map((it) => (
                    <li key={it} className="flex items-start gap-2.5 text-sm text-slate-300">
                      <Check size={15} className="text-mint mt-0.5 shrink-0" strokeWidth={2.6} />
                      {it}
                    </li>
                  ))}
                </ul>
                <a
                  data-testid={`package-quote-button-${p.id}`}
                  href={waLink(`Hi OGO! I'd like a quote for the ${p.name} package.`)}
                  target="_blank"
                  rel="noreferrer"
                  className={`mt-8 inline-flex items-center justify-center gap-2 rounded-full font-semibold text-sm px-5 py-3.5 transition-colors duration-300 ${
                    p.featured ? "bg-gold text-ink hover:bg-white" : "border border-white/20 text-white hover:border-gold hover:text-gold"
                  }`}
                >
                  <MessageCircle size={15} /> {t.packages.quote}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
